import React, { Component } from 'react';
import VimeoVideo from "./appraisal/vimeo-video";
import jsPDF from 'jspdf';
import moment from 'moment';
import html2canvas from 'html2canvas';
  
let pickup = [],pickupAppraisalPath=[];        
let dropoff = [],dropoffAppraisalPath=[];

export default class JobFullDetailsAppraisal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      appraisal_data: props.appraisal_data || null,
      type: props.type || null,
      isLoadingAppraisalInfo: props.isLoadingAppraisalInfo || true,
      defaultDriver:null,
      dropoffDriver:null,
      customerAllJobsPage: props.customerAllJobsPage || false,
      isDownloadClick : false
    };
    this.getDefaultDriverJobA = this.getDefaultDriverJobA.bind(this);
    this.getDefaultDriverJobB = this.getDefaultDriverJobB.bind(this);
  }
  componentDidMount() {
      
  }
  getDefaultDriverJobA(jobId) {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/default/for-dropdown-menu/"+jobId,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(defaultDriverJson) {
        if(defaultDriverJson != null){
            that.setState({defaultDriver: defaultDriverJson.first_name + ' '+defaultDriverJson.last_name});
        }else{
            let defaultDriver = (this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null;
            that.setState({defaultDriver: defaultDriver});
        }
    });
  }
  getDefaultDriverJobB(jobId) {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/drivers/default/for-dropdown-menu/"+jobId,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(defaultDriverJson) {
        if(defaultDriverJson != null){
            that.setState({dropoffDriver: defaultDriverJson.first_name + ' '+defaultDriverJson.last_name});
        }else{
            let defaultDriver = (this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null;
            that.setState({dropoffDriver: defaultDriver});
        }
    });
  }
  handleOnlyPickupAppraisal(multi_array, search_key, parent = ''){
      if (multi_array != null){
        Object.keys(multi_array).forEach((key, index) => {
          if (typeof multi_array[key] == 'object') {
            if (search_key == key) {
              pickup[parent] = multi_array[key];
            } else {
              this.handleOnlyPickupAppraisal(multi_array[key], search_key, key);
            }
          }
        });
      }
    return pickup; 
  }
  handleOnlyDropoffAppraisal(multi_array, search_key, parent = ''){
      if (multi_array != null){
        Object.keys(multi_array).forEach((key, index) => {
          if (typeof multi_array[key] == 'object') {
            if (search_key == key) {
              dropoff[parent] = multi_array[key];
            } else {
              this.handleOnlyDropoffAppraisal(multi_array[key], search_key, key);
            }
          }
        });
      }
    return dropoff; 
  }
  diff(obj1, obj2, exclude) {
    let r = {};

    if (!exclude) exclude = [];

    for (let prop in obj1) {
      if (Object.keys(obj1).length > 0 && obj1.hasOwnProperty(prop) && prop != '__proto__') {
        if (exclude.indexOf(obj1[prop]) == -1) {
          if (Object.keys(obj2).length > 0 !==  null && !obj2.hasOwnProperty(prop)) r[prop] = obj1[prop];
          else if (obj1[prop] === Object(obj1[prop])) {
            if(obj1[prop] !== null &&  obj2[prop] !== null){
              let difference = this.diff(obj1[prop], obj2[prop]);
              if (Object.keys(difference).length > 0) r[prop] = difference;
            }
          }

          else if (obj1[prop] !== obj2[prop]) {
            if (obj1[prop] === undefined)
              r[prop] = 'undefined';
            if (obj1[prop] === null)
              r[prop] = null;
            else if (typeof obj1[prop] === 'function')
              r[prop] = 'function';
            else if (typeof obj1[prop] === 'object')
              r[prop] = 'object';
            else
              r[prop] = obj1[prop];
          }
        }
      }
    }

    return r;
  }
  handleOnlyPickupAppraisalPath(arr, path=null){
      let nextpath = "";
      if (typeof arr == 'object') {
            let current = [];
            Object.keys(arr).forEach((key, index) => {
                if (typeof arr[key] == 'object') {
                    nextpath = (path == null) ? (key+':') : (path + key+':');
                    if(arr[key] !== null){
                      current.push(this.handleOnlyPickupAppraisalPath(arr[key], nextpath));
                    }
                }else{
                    let keyval = path + key;
                    pickupAppraisalPath[keyval] = arr[key];
                    
                }
            });
            return pickupAppraisalPath;
        }else {
            return false;
        }
  }
  handleOnlyDropoffAppraisalPath(arr, path=null){
      let nextpath = "";
      if (typeof arr == 'object') {
            let current = [];
            Object.keys(arr).forEach((key, index) => {
                if (typeof arr[key] == 'object') {
                    nextpath = (path == null) ? (key+':') : (path + key+':');
                    if(arr[key] !== null){
                      current.push(this.handleOnlyDropoffAppraisalPath(arr[key], nextpath));
                    }
                }else{
                    let keyval = path + key;
                    dropoffAppraisalPath[keyval] = arr[key];
                    
                }
            });
            return dropoffAppraisalPath;
        }else {
            return false;
        }
  }
  approveAppraisal(e,type){
    return fetch('/api/v1/portal/jobs/'+this.state.data.id+'/approve-appraisal/'+type,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Job appraisal is approved');
      } else {
        alert('Something went wrong..');
      }
    }).catch((error) => { 
      alert('Something went wrong..');
    });
  }
  unapproveAppraisal(e,type){
    return fetch('/api/v1/portal/jobs/'+this.state.data.id+'/un-approve-appraisal/'+type,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Job appraisal is unapproved');
      } else {
        alert('Something went wrong..');
      }
    }).catch((error) => { 
      alert('Something went wrong..');
    });
  }
  sendAppraisalPdfMailToCustomer(e,type){
    return fetch('/api/v1/portal/jobs/'+this.state.data.id+'/send-appraisal-pdf-mail-to-customer/'+type,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      if (response.ok) {
        alert('Mail sent to customer...');
      } else {
        let res = response.json();
        res.then((resJson) => {
          //alert(resJson);
          alert('There is issue with some data of jobs please check . . .');
        });
        // alert('Unable to sent mail..');
      }
    }).catch((error) => { 
      alert('Unable to sent mail..'+error);
    });
  }
  handleCheckDiffAppraisals(){
        let infoModal = $('#infomodal');
        document.querySelector('#infomodallabel').innerHTML = 'Appraisals Difference';
         
        /********************* Only work for React *******************************************/
        let appraisal_data = this.state.appraisal_data;
        let jobId = this.state.data.id;
        appraisal_data = JSON.stringify(appraisal_data);
        appraisal_data = JSON.parse(appraisal_data);  

        let pickupAppraisal =  this.handleOnlyPickupAppraisal(appraisal_data,'pickup');
        let dropoffAppraisal =  this.handleOnlyDropoffAppraisal(appraisal_data,'dropoff');
        let outputDiff = [];
        outputDiff['pickup'] = this.diff(pickupAppraisal, dropoffAppraisal);
        outputDiff['dropoff'] = this.diff(dropoffAppraisal, pickupAppraisal);
        
        let appraisalPickRes = this.handleOnlyPickupAppraisalPath(outputDiff['pickup']);
        let appraisalDropoffRes = this.handleOnlyDropoffAppraisalPath(outputDiff['dropoff']);
        /********************* Only work for React *******************************************/
        if(appraisalPickRes != null || appraisalPickRes != "" && appraisalDropoffRes != null || appraisalDropoffRes != ""){
            let appraisalDiff = Object.keys(appraisalPickRes).map((key)=> {
                if(appraisalPickRes[key] !== undefined && appraisalDropoffRes[key] !== undefined){
                    let tdPickVal = "";
                    let tdDropoffVal = "";
                    let imgsrcP = "";
                    let imgsrcD = "";
                    
                    if(key.match(/uploadcare_image_urls/g) || key.match(/uploadcare_signature_image/g) || key.match(/photo_names/g) || key.match(/signature_image/g)){
                        if(key.match(/uploadcare_image_urls/g)){
                            imgsrcP = appraisalPickRes[key];
                        }else if(key.match(/uploadcare_signature_image/g)){
                            imgsrcP = appraisalPickRes[key];
                        }else{
                            imgsrcP = '/storage/images/jobs/'+jobId+'/appraisal_images/'+appraisalPickRes[key];
                        }
                        tdPickVal = '<a href="'+imgsrcP+'" target="_blank"><img src='+imgsrcP+' width="150" class="appimgsrc" onerror="this.onerror=null;this.src=\'/images/placeholders/driver-app.png\';"></a>';
                    }else{
                        tdPickVal = appraisalPickRes[key];
                    }
                    if(key.match(/uploadcare_image_urls/g) || key.match(/uploadcare_signature_image/g) || key.match(/photo_names/g) || key.match(/signature_image/g)){
                        if(key.match(/uploadcare_image_urls/g)){
                            imgsrcD = appraisalDropoffRes[key];
                        }else if(key.match(/uploadcare_signature_image/g)){
                            imgsrcD = appraisalDropoffRes[key];
                         }else{
                            imgsrcD = '/storage/images/jobs/'+jobId+'/appraisal_images/'+appraisalDropoffRes[key];
                        }
                        tdDropoffVal = '<a href="'+imgsrcD+'" target="_blank"><img src='+imgsrcD+' width="150" class="appimgsrc" onerror="this.onerror=null;this.src=\'/images/placeholders/driver-app.png\';"></a>';
                    }else{
                        tdDropoffVal = appraisalDropoffRes[key];
                    }
                    
                    let resKey = key.replace(/_/g,' ').replace(/:0/g,' ').replace(/:/g,' ').replace(/entry/g,' ').replace(/values/g,' ');
                    if(!resKey.match(/label/g)){
                        let html = '<tr><td><b>'+resKey+'</b></td><td>'+tdPickVal+'</td>';
                        html += '<td>'+tdDropoffVal+'</td></tr>';
                        return html;
                    }
                }
            });

            let appraisalDifferences = '<table class="appraisalDiffDataTBL" >\n\
                            <thead>\n\
                                <th>DETAILS</th>\n\
                                <th>PICKUP</th>\n\
                                <th>DROPOFF</th>\n\
                            </thead>\n\
                            <tbody>'+appraisalDiff+'</tbody>\n\
                        </table>';

            appraisalDifferences =  appraisalDifferences.replace(/\,/g,"");
            document.querySelector('#infomodal .modal-body').innerHTML = appraisalDifferences;
        }else{
            document.querySelector('#infomodal .modal-body').innerHTML = 'No matches found!';
        }
        infoModal.modal();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      isLoadingAppraisalInfo: nextProps.isLoadingAppraisalInfo,
      appraisal_data: nextProps.appraisal_data,
      defaultDriver:(this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null,
      dropoffDriver:(this.state.data.driver_id !== null && this.state.data.driver !== null) ? 
                    this.state.data.driver.user.first_name + ' '+this.state.data.driver.user.last_name : null   
    });
    if(nextProps.data.has_split_jobs == 1){
        this.getDefaultDriverJobA(this.state.data.split_child_a_id);
        this.getDefaultDriverJobB(this.state.data.split_child_b_id);
    }
  }
  downloadAppraisalForJob(e, selector, time) {
    this.setState({isDownloadClick:true})
    $('.pickDropAppraisal').addClass('buttonDisabled');
    let regNumber = (this.state.data != null) ? this.state.data.vehicle.registration_number : "";
    let csvFileName = regNumber+'-appraisal-download-job-'+this.state.data.id+'-'+this.state.type+'-appraisal-'+time.toString()+'.pdf';
    return fetch('/api/v1/portal/appraisal-info/job/'
      +this.state.data.id+'/'+this.state.type+'/appraisal-download',
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }
    ).then((response) => {
      $('.pickDropAppraisal').removeClass('buttonDisabled');
      this.setState({isDownloadClick:false})
      if (response.ok) {
        return response.blob();
      } else {
        throw new Error('Appraisal not found for this job.');
      }
    })
    .then((blob) => {
        this.setState({isDownloading: false});
        this.setState({isDownloadClick:false})
        $('.pickDropAppraisal').removeClass('buttonDisabled');
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = csvFileName;
        document.body.appendChild(a); 
        a.click();    
        a.remove();
    })
    .catch((error) => {
      $('.pickDropAppraisal').removeClass('buttonDisabled');
      this.setState({isDownloadClick:false})
      alert(error);
    });
    /*console.log("in downloadAppraisalForJob")
    e.preventDefault();

    var element = document.getElementById(selector);
    var opt = {
      margin:       1,
      filename:     'myfile.pdf',
      image:        { type: 'jpeg', quality: 0.98 }, 
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
 
    // New Promise-based usage:
    html2pdf().from(element).set(opt).save();
    console.log("return before");
    return;
    console.log("return after");*/    

    // html2canvas(document.getElementById(
    //   selector
    // ), {
    //   useCORS: true,
    //   dpi: 96,
    //   scale: 1
    // }).then(function(canvas) {
    //   makePdf(canvas);
    // });
    // let regNumber = (this.state.data != null) ? this.state.data.vehicle.registration_number : "";
    // let makePdf = function(canvas) {
    //   let appraisalImageForPdf = canvas.toDataURL("image/png"),
    //     position = 0,
    //     imageWidth = 210,
    //     imageHeight = canvas.height * imageWidth / canvas.width,
    //     pageHeight = 295,
    //     heightLeft = imageHeight,
    //     pdf = new jsPDF('p', 'mm');
    //   pdf.addImage(
    //     appraisalImageForPdf,
    //     'PNG',
    //     0,
    //     position,
    //     imageWidth,
    //     imageHeight,
    //     undefined,
    //     'slow'
    //   );
    //   heightLeft -= pageHeight;
    //   while (heightLeft >= 0) {
    //     position = heightLeft - imageHeight;
    //     pdf.addPage();
    //     pdf.addImage(
    //       appraisalImageForPdf,
    //       'PNG',
    //       0,
    //       position,
    //       imageWidth,
    //       imageHeight,
    //       undefined,
    //       'slow'
    //     );
    //     heightLeft -= pageHeight;
    //   }
    //   alert('PDF Generated!');
    //   pdf.save(
    //     regNumber+'-appraisal-download-'+
    //     selector+
    //     '-'+
    //     time.toString()+
    //     '.pdf'
    //   );
    // }
  }
  renderManualAppraisalVehiclePhotos(appraisal, type) {
    let ii = 0,
      ManualAppraisalVehiclePhotos = [];

    if (appraisal.manual_appraisal &&
      appraisal.manual_appraisal[type] &&
      appraisal.manual_appraisal[type].vehicle_info &&
      appraisal.manual_appraisal[type].vehicle_info.photo_names &&
      appraisal.manual_appraisal[type].vehicle_info.photo_names.length > 0) {
      let jobId = this.state.data.id;
       /* use first child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
            jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
            jobId = this.state.data.split_child_b_id;
        }
      appraisal.manual_appraisal[type].vehicle_info.photo_names.forEach(function(i) {
        ii++;
        ManualAppraisalVehiclePhotos.push(
          <img
            src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}

            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/driver-app.png"
            }}
            key={'job-'+jobId+'-vehicle-photos-'+ii} />);
      });
    }
    return (
      <div className="appraisal-images-container">{ManualAppraisalVehiclePhotos}</div>
    )
  }
  renderManualAppraisalVehicleInfoLine(info) {
    if (!info || !info.label || !info.values) {
      return null;
    }
    if(info.label == "Uploadcare Photos" && info.values.length > 0){
      let additionalImages = [];
      let jobId = this.state.data.id;
       /* use first child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && this.state.type == 'pickup'){
            jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && this.state.type == 'dropoff'){
            jobId = this.state.data.split_child_b_id;
        }
      info.values.forEach(function(i,index) {
        additionalImages.push(
          <img className="img-responsive"
            src={i}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/driver-app.png"
            }}
            key={'job-'+jobId+'-additional-photos-'+index} />);
      });

      return (
        <div className="appraisal-vehicle-info-line col-md-4 col-sm-12">
          <div className="appraisal-vehicle-info-line-label">Additional Images</div>
          <div className="appraisal-vehicle-info-line-value additional-images-block">{additionalImages}</div>
        </div>
      )
    }else{
      let additionalImages = [];
      if(info.label == "UploadCare Photos"){
        let jobId = this.state.data.id;
        /* use first child job ID for photo_name */
          if(this.state.data.has_split_jobs == 1 && this.state.type == 'pickup'){
              jobId = this.state.data.split_child_a_id;
          }
          /* use second child job ID for photo_name */
          if(this.state.data.has_split_jobs == 1 && this.state.type == 'dropoff'){
              jobId = this.state.data.split_child_b_id;
          }
        info.values.forEach(function(i,index) {
          additionalImages.push(
            <img className="img-responsive"
              src={i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              key={'job-'+jobId+'-additional-photos-'+index} />);
        });
      }
      let bgColor = (info.label.toLowerCase() == 'notes' && (info.values[0] !== null)) ? 'redalert' :'';
      return (
        <div className={bgColor + " appraisal-vehicle-info-line col-md-4 col-sm-12"}>
          <div className="appraisal-vehicle-info-line-label">{info.label}</div>
          <div className="appraisal-vehicle-info-line-value">
          {(info.label == "UploadCare Photos") ? 
              additionalImages
              :
              info.values[0]}
          </div>
        </div>
      )
    }
  }
  renderManualAppraisalVehicleInfo(appraisal, type) {
    if(appraisal.manual_appraisal[type].vehicle_info)
    {
    if (this.state.data.manual_appraisal_required === 1 &&
      appraisal.manual_appraisal) {
      if (this.state.data.vehicle.type === 'car') {
        return (
          <div>
            <div className="appraisal-vehicle-info-line-container row">
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.aerial
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.adas_warning_light
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.is_camera_setup_dashboard
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.clean_exterior
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.condition_of_sill
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.condition_of_tyres
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.does_it_smell_of_smoke
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.exterior_stickers_present
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.handbook
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.head_rests
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.inflation_kit
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.interior
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.locking_wheel_nut
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.number_of_carpet_mats
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.number_of_keys
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.parcel_shelf
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.sat_nav_disc_sd_card
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.service_book
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.spare_wheel
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.tool_and_jack
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.tread_depth
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.tyre_pressure
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.visibility
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.weather
              )}

              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.notes
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.v5_registration_document
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.uploadcare_image_urls
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.does_charging_cable_attached
              )}
            </div>
            {this.renderManualAppraisalVehiclePhotos(appraisal, type)}
          </div>
        );
      }

      if (this.state.data.vehicle.type === 'van') {
        return (
          <div>
            <div className="appraisal-vehicle-info-line-container row">
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.aerial
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.adas_warning_light
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.is_camera_setup_dashboard
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.condition_of_sill
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.condition_of_tyres
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.clean_exterior
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.does_it_smell_of_smoke
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.exterior_stickers_present
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.handbook
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.head_rests
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.interior
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.inflation_kit
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.tool_and_jack
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.tread_depth
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.tyre_pressure
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.locking_wheel_nut
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.number_of_carpet_mats
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.number_of_keys
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.parcel_shelf
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.sat_nav_disc_sd_card
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.service_book
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.spare_wheel
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.visibility
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.weather
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.notes
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.v5_registration_document
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.uploadcare_image_urls
              )}
              {this.renderManualAppraisalVehicleInfoLine(
                appraisal.manual_appraisal[type].vehicle_info.does_charging_cable_attached
              )}
            </div>
            {
              this.renderManualAppraisalVehiclePhotos(
                appraisal,
                type
              )
            }
          </div>
        );
      }
    }
    else {
      return <div>Manual Appraisal not required</div>
    }
    }
  }
  renderManualAppraisalVehiclePartLine(part,isSingleValue = false) {
    let ii = 0, VehiclePartImages = [], VehiclePartDamages = [];
    let type = this.state.type;
    if (!part) {
      return false;
    }
    let keyPart = part.label.replace(/\s+/g, '-').toLowerCase();
    if (part && part.uploadcare_image_urls && part.uploadcare_image_urls.length > 0) {
      if(part.uploadcare_image_urls[0].includes("https://")){
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        part.uploadcare_image_urls.forEach(function(i) {
          ii++
          VehiclePartImages.push(
            <img src={i}
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}

                 key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
          );
        });
      }else if (part && part.photo_names && part.photo_names.length > 0) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
         /* use first child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
            jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
            jobId = this.state.data.split_child_b_id;
        }
        part.photo_names.forEach(function(i) {
          ii++;
          VehiclePartImages.push(
            <img
              src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
              onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}

                 key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
          );
        });
      }
    }else if (part && part.photo_names && part.photo_names.length > 0) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
       /* use first child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
            jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
            jobId = this.state.data.split_child_b_id;
        }
      part.photo_names.forEach(function(i) {
        ii++;
        VehiclePartImages.push(
          <img
            src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
            onError={(e) => {
                 e.target.onerror = null;
                 e.target.src = "/images/placeholders/driver-app.png"
               }}

               key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
        );
      });
    }else if (isSingleValue == true && part && part.uploadcare_image_url && part.uploadcare_image_url != null) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
        VehiclePartImages.push(
        <img src={part.uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/driver-app.png"
            }}

            key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
      );
    }

    if (part && part.damages && part.damages.values &&
      part.damages.values.length > 0) {
      let jobId = this.state.data.id;
      part.damages.values.forEach(function(i) {
        ii++;
        VehiclePartDamages.push(
          <div key={'job-'+jobId+'-damage-'+ii+'-'+keyPart}
               className="vehicle-damage-label">{i}</div>
        );
      });
    }

    return (
      <div className="appraisal-vehicle-part-line col-md-6 col-sm-12">
        <div className="appraisal-vehicle-part-line-label">
          {part.label}
        </div>
        <div className="appraisal-vehicle-part-line-damages">
          {ii > 0 ?
            <strong>Damages:</strong>
            : null }
          {VehiclePartDamages}
        </div>
        <div className="appraisal-vehicle-part-line-images">
          {VehiclePartImages}
        </div>
      </div>
    )
  }
  renderNewKeysAboveMileage(part){
    let ii = 0,VehiclePartImages = [];
    if (part && part.uploadcare_image_url && part.uploadcare_image_url != null) {
      let keyPart = part.label.replace(/\s+/g, '-').toLowerCase();
      
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
        VehiclePartImages.push(
        <img src={part.uploadcare_image_url}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/placeholders/driver-app.png"
            }}
            key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
      );
    }
    return (
      <div className="appraisal-mileage-images-container">
          {VehiclePartImages}
      </div>
    )
  }
  renderManualAppraisalVehicleParts(appraisal, type) {
    if(appraisal.manual_appraisal[type].vehicle_parts)
    {
    if (this.state.data.manual_appraisal_required === 1 &&
      appraisal.manual_appraisal &&
      appraisal.manual_appraisal[type]) {

      if (this.state.data.vehicle.type === 'car') {
        return (
          <div className="appraisal-vehicle-part-line-container row">
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_bumper
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_driver_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_driver_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_driver_panel
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_driver_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_driver_window
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_light_driver
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_light_passenger
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_passenger_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_passenger_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_passenger_panel
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_passenger_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_passenger_window
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.bonnet
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.boot
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_head_light
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_wing_mirror
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_bumper
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_driver_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_driver_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_driver_panel
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_driver_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_driver_window
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_passenger_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_passenger_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_passenger_panel
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_passenger_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_passenger_window
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.inside
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_head_light
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_wing_mirror
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.rear_window
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.roof
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.windscreen
            )}
          </div>
        );
      }

      if (this.state.data.vehicle.type === 'van') {
        return (
          <div className="appraisal-vehicle-part-line-container row">
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_bumper
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_driver_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_driver_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_passenger_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.back_passenger_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.bonnet
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_side_front_panel
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_side_window
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_wing_mirror
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_side
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.driver_head_light
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_bumper
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_driver_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_driver_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_passenger_tyre
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.front_passenger_alloy
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.inside
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_side
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_head_light
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_side_window
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_wing_mirror
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.passenger_side_front_panel
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.slide_door
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.tail_light_driver
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.tail_light_passenger
            )}
            {this.renderManualAppraisalVehiclePartLine(
              appraisal.manual_appraisal[type].vehicle_parts.windscreen
            )}
          </div>
        );
      }
    }
    else {
      return (<div>Manual Appraisal not required</div> )
    }
    }
  }

  renderManualAppraisalMileageImages(appraisal, type) {
    let MileageImages = [];
    if (appraisal.mileage &&
      appraisal.mileage[type] &&
      appraisal.mileage[type].uploadcare_image_urls &&
      appraisal.mileage[type].uploadcare_image_urls.length > 0) {
      if(appraisal.mileage[type].uploadcare_image_urls[0].includes("https://")){
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        appraisal.mileage[type].uploadcare_image_urls.forEach(function(i) {
          MileageImages.push(
            <img src={i}
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}
                 key={'job-'+jobId+'-mileage-'+i} />
          );
        });
      }else if (appraisal.mileage &&
        appraisal.mileage[type] &&
        appraisal.mileage[type].photo_names &&
        appraisal.mileage[type].photo_names.length > 0) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        /* use first child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
            jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
            jobId = this.state.data.split_child_b_id;
        }
        appraisal.mileage[type].photo_names.forEach(function(i) {
          MileageImages.push(
            <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}
                 key={'job-'+jobId+'-mileage-'+i} />
          );
        });
      }
    }
    else if (appraisal.mileage &&
      appraisal.mileage[type] &&
      appraisal.mileage[type].photo_names &&
      appraisal.mileage[type].photo_names.length > 0) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
      /* use first child job ID for photo_name */
      if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
          jobId = this.state.data.split_child_a_id;
      }
      /* use second child job ID for photo_name */
      if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
          jobId = this.state.data.split_child_b_id;
      }
      appraisal.mileage[type].photo_names.forEach(function(i) {
        MileageImages.push(
          <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
               onError={(e) => {
                 e.target.onerror = null;
                 e.target.src = "/images/placeholders/driver-app.png"
               }}
               key={'job-'+jobId+'-mileage-'+i} />
        );
      });
    }
    return (
      <div className="appraisal-mileage-images-container">{MileageImages}</div>
    )
  }

  renderManualAppraisalPetrolLevelImages(appraisal, type) {
    let PetrolLevelImages = [];
    if (appraisal.petrol_level &&
      appraisal.petrol_level[type] &&
      appraisal.petrol_level[type].uploadcare_image_urls &&
      appraisal.petrol_level[type].uploadcare_image_urls.length > 0) {
      if(appraisal.petrol_level[type].uploadcare_image_urls[0].includes("https://")){
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        appraisal.petrol_level[type].uploadcare_image_urls.forEach(function(i) {
          PetrolLevelImages.push(
            <img src={i}
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}
                 key={'job-'+jobId+'-petrol-'+i} />);
        });
      }else if (appraisal.petrol_level &&
        appraisal.petrol_level[type] &&
        appraisal.petrol_level[type].photo_names &&
        appraisal.petrol_level[type].photo_names.length > 0) {
        let jobId = this.state.data.id;
        if (this.state.data.subcontracted_parent_job_id === null &&
          this.state.data.subcontracted_job_id !== null) {
          jobId = this.state.data.subcontracted_job_id;
        }
        /* use first child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
            jobId = this.state.data.split_child_a_id;
        }
        /* use second child job ID for photo_name */
        if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
            jobId = this.state.data.split_child_b_id;
        }
        appraisal.petrol_level[type].photo_names.forEach(function(i) {
          PetrolLevelImages.push(
            <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}
                 key={'job-'+jobId+'-petrol-'+i} />);
        });
      }
    }else if (appraisal.petrol_level &&
      appraisal.petrol_level[type] &&
      appraisal.petrol_level[type].photo_names &&
      appraisal.petrol_level[type].photo_names.length > 0) {
      let jobId = this.state.data.id;
      if (this.state.data.subcontracted_parent_job_id === null &&
        this.state.data.subcontracted_job_id !== null) {
        jobId = this.state.data.subcontracted_job_id;
      }
        /* use first child job ID for photo_name */
         if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
             jobId = this.state.data.split_child_a_id;
         }
         /* use second child job ID for photo_name */
         if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
             jobId = this.state.data.split_child_b_id;
         }
      appraisal.petrol_level[type].photo_names.forEach(function(i) {
        PetrolLevelImages.push(
          <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
               onError={(e) => {
                 e.target.onerror = null;
                 e.target.src = "/images/placeholders/driver-app.png"
               }}
               key={'job-'+jobId+'-petrol-'+i} />);
      });
    }
    return (
      <div className="appraisal-petrol-level-images-container">
        {PetrolLevelImages}
      </div>
    )
  }

  renderAppraisalFeedbackQuestions(appraisal, type) {
    let AppraisalFeedbackQuestionsBlock = [];
    if(!appraisal.customer_signatures)
    {
      appraisal.customer_signatures = appraisal.manual_appraisal.customer_signatures;
    }
    if(type === 'pickup'){
      if(appraisal.customer_signatures && appraisal.customer_signatures.pickup && appraisal.customer_signatures.pickup.welldress && appraisal.customer_signatures.pickup.welldress.values){
        if(appraisal.customer_signatures.pickup.welldress.label && appraisal.customer_signatures.pickup.welldress.values !== null){
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.pickup.welldress.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.pickup.welldress.values[0]}</div>
            </div>
          ); 
        }
      }
      if(appraisal.customer_signatures && appraisal.customer_signatures.pickup && appraisal.customer_signatures.pickup.driverbehaviour && appraisal.customer_signatures.pickup.driverbehaviour.values){
        if(appraisal.customer_signatures.pickup.driverbehaviour.label && appraisal.customer_signatures.pickup.driverbehaviour.values !== null){
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.pickup.driverbehaviour.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.pickup.driverbehaviour.values[0]}</div>
            </div>
          ); 
        }
      }
      if(appraisal.customer_signatures && appraisal.customer_signatures.pickup && appraisal.customer_signatures.pickup.driverexperience && appraisal.customer_signatures.pickup.driverexperience.values){
        if(appraisal.customer_signatures.pickup.driverexperience.label && appraisal.customer_signatures.pickup.driverexperience.values !== null){
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.pickup.driverexperience.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.pickup.driverexperience.values[0]}</div>
            </div>
          ); 
        }
      }
    }else if(type === 'dropoff'){
      if(appraisal.customer_signatures && appraisal.customer_signatures.dropoff && appraisal.customer_signatures.dropoff.welldress && appraisal.customer_signatures.dropoff.welldress.values){
        if(appraisal.customer_signatures.dropoff.welldress.label && appraisal.customer_signatures.dropoff.welldress.values !== null){
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.dropoff.welldress.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.dropoff.welldress.values[0]}</div>
            </div>
          ); 
        }
      }
      if(appraisal.customer_signatures && appraisal.customer_signatures.dropoff && appraisal.customer_signatures.dropoff.driverbehaviour && appraisal.customer_signatures.dropoff.driverbehaviour.values){
        if(appraisal.customer_signatures.dropoff.driverbehaviour.label && appraisal.customer_signatures.dropoff.driverbehaviour.values !== null){
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.dropoff.driverbehaviour.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.dropoff.driverbehaviour.values[0]}</div>
            </div>
          ); 
        }
      }
      if(appraisal.customer_signatures && appraisal.customer_signatures.dropoff && appraisal.customer_signatures.dropoff.driverexperience && appraisal.customer_signatures.dropoff.driverexperience.values){
        if(appraisal.customer_signatures.dropoff.driverexperience.label && appraisal.customer_signatures.dropoff.driverexperience.values !== null){
          AppraisalFeedbackQuestionsBlock.push(
            <div className="appraisal-feedback-question col-md-4 col-sm-12">
              <div className="appraisal-feedback-question-label">{appraisal.customer_signatures.dropoff.driverexperience.label}</div>
              <div className="appraisal-feedback-question-value">{appraisal.customer_signatures.dropoff.driverexperience.values[0]}</div>
            </div>
          ); 
        }
      }
    }

    if(AppraisalFeedbackQuestionsBlock.length){
      return(
        <div className="appraisal-feedback-question-container row">
          {AppraisalFeedbackQuestionsBlock}
        </div>
      )
    }else{
      return(
        <div className="appraisal-feedback-question-container row">
          No appraisal feedback found.
        </div>
      )
    }
  }

  renderAppraisalInfoBlock(type) {
    let appraisal = this.state.appraisal_data;
    let appraisalInfoBlock;
    let signatureBlock = [];
    let jobId = this.state.data.id;
    if (this.state.data.subcontracted_parent_job_id === null &&
      this.state.data.subcontracted_job_id !== null) {
      jobId = this.state.data.subcontracted_job_id;
    }
    
    if (typeof appraisal == "object" && "customer_signatures" in appraisal) {
      if ((type === 'pickup') &&
        "pickup" in appraisal.customer_signatures) {
        let appraisalPickupSignatureImage;
        if(appraisal.customer_signatures && appraisal.customer_signatures[type] && appraisal.customer_signatures[type].uploadcare_signature_image)
        {
          if(appraisal.customer_signatures[type].uploadcare_signature_image.includes("https://"))
          {
            appraisalPickupSignatureImage = <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/driver-app.png"
                }}
                src={
                  appraisal.customer_signatures[type].uploadcare_signature_image
                } className="job-customer-signature-image" />;
          }else{
              
            /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }
            appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              src={
                "/storage/images/jobs/"+jobId+"/signature_images/"+
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image" />;
          }
        }
        else
        {
            
          /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }  
          appraisalPickupSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              src={
                "/storage/images/jobs/"+jobId+"/signature_images/"+
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image" />;
        }
        signatureBlock.push (
          <div key={'job-'+jobId+'-'+type+'-signature'}>
            <h5>{type} Signature</h5>
            Signed By: {
            appraisal.customer_signatures[type].signed_by
          }<br />
            Time Signed: {
            moment(
              appraisal.customer_signatures[type].date_signed
            ).format(
              'ddd Do MMM YYYY - HH:mm:ss'
            ).toString()
          }<br />
            Location:&nbsp;
            {this.state.data.pickup_address.house_number_or_name ?
              this.state.data.pickup_address.house_number_or_name+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_1 ?
              this.state.data.pickup_address.address_line_1+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_2 ?
              this.state.data.pickup_address.address_line_2+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.address_line_3 ?
              this.state.data.pickup_address.address_line_3+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.town_city?
              this.state.data.pickup_address.town_city+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.county?
              this.state.data.pickup_address.county+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.country?
              this.state.data.pickup_address.country+
              ', ' :
              ''
            }
            {this.state.data.pickup_address.postcode?
              this.state.data.pickup_address.postcode+
              ' ' :
              ''
            }
            <br />
           {appraisalPickupSignatureImage}
          </div>
        );
      }
      else if ((type === 'dropoff') &&
        "dropoff" in appraisal.customer_signatures) {
        let appraisalDropoffSignatureImage;
        if(appraisal.customer_signatures && appraisal.customer_signatures[type] && appraisal.customer_signatures[type].uploadcare_signature_image)
        {
          if(appraisal.customer_signatures[type].uploadcare_signature_image.includes("https://")){
            appraisalDropoffSignatureImage = <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/driver-app.png"
                }}
                src={
                  appraisal.customer_signatures[type].uploadcare_signature_image
                } className="job-customer-signature-image" />;
          }else{
              
              /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }
            appraisalDropoffSignatureImage = <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/placeholders/driver-app.png"
                }}
                src={
                  "/storage/images/jobs/"+jobId+"/signature_images/"+
                  appraisal.customer_signatures[type].signature_image
                } className="job-customer-signature-image" />;
          }
        }
        else
        {
            
          /* use first child job ID for photo_name */
            if(this.state.data.has_split_jobs == 1 && type == 'pickup'){
                jobId = this.state.data.split_child_a_id;
            }
            if(this.state.data.has_split_jobs == 1 && type == 'dropoff'){
                jobId = this.state.data.split_child_b_id;
            }
          appraisalDropoffSignatureImage = <img
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              src={
                "/storage/images/jobs/"+jobId+"/signature_images/"+
                appraisal.customer_signatures[type].signature_image
              } className="job-customer-signature-image" />;
        }
        signatureBlock = (
          <div key={'job-'+jobId+'-'+type+'-signature'}>
            <h5>{type} Signature</h5>
            Signed By: {
            appraisal.customer_signatures[type].signed_by
          }<br />
            Time Signed: {
            moment(
              appraisal.customer_signatures[type].date_signed
            ).format(
              'ddd Do MMM YYYY - HH:mm:ss'
            ).toString()
          }<br />
            Location:&nbsp;
            {
              this.state.data.dropoff_address.house_number_or_name ?
                this.state.data.dropoff_address.house_number_or_name+
                ', ' :
                ''
            }
            {this.state.data.dropoff_address.address_line_1 ?
              this.state.data.dropoff_address.address_line_1+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_2 ?
              this.state.data.dropoff_address.address_line_2+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.address_line_3 ?
              this.state.data.dropoff_address.address_line_3+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.town_city?
              this.state.data.dropoff_address.town_city+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.county?
              this.state.data.dropoff_address.county+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.country?
              this.state.data.dropoff_address.country+
              ', ' :
              ''
            }
            {this.state.data.dropoff_address.postcode?
              this.state.data.dropoff_address.postcode+
              ' ' :
              ''
            }
            <br />
            {appraisalDropoffSignatureImage}
          </div>
        );
      }
      else {
        signatureBlock.push (
          <div key={'job-'+jobId+'--signature'}>
            <h5>Signature - not collected yet</h5>
          </div>
        );
      }
    }
    else {
      signatureBlock.push (
        <div key={'job-'+jobId+'--signature'}>
          <h5>Signature - not collected yet</h5>
        </div>
      );
    }
    if (typeof appraisal == "object" && "number_plate" in appraisal) {
      let diffOfMiles = (appraisal.mileage && appraisal.mileage[type] && appraisal.mileage[type].entry) ? ((appraisal.mileage['dropoff'].entry) - (appraisal.mileage['pickup'].entry)) : 0;
      appraisalInfoBlock = (
        <div
          className="text-left"
          key={'appraisal-info-block-for-'+appraisal.id}>
          {this.state.type == 'dropoff' ? 
            <div>
              <br />
              <h5>Difference between pick up and drop off miles:&nbsp;
                  <strong>
                      {diffOfMiles}
                  </strong>
              </h5>
            </div> 
          : ""}
          <hr />
          <br />
          <div className="row">
            <div className="col-md-4">
              Driver Name: <strong>
              {(this.state.defaultDriver !== null && this.state.type == 'pickup') ?
                <span>{this.state.defaultDriver}</span>
                :
                 (this.state.dropoffDriver !== null && this.state.type == 'dropoff') ? <span>{this.state.dropoffDriver}</span>:       
                <span>No Driver</span>
              }
            </strong>
            </div>
            <div className="col-md-8 col-sm-12">
              <div className="row">
                <div className="col-md-4">
                  Customer Name:<br /><strong>
                  {this.state.data.customer.name}
                </strong>
                </div>
                <div className="col-md-4">
                  Order Number:<br /><strong>
                  {this.state.data.customer_order_number}
                </strong>
                </div>
                <div className="col-md-4">
                  Job Number:<br /><strong>
                  {this.state.data.customer_job_number}
                </strong>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-md-12">
              <h4>Notes</h4>
              {this.state.data.notes}
            </div>
          </div>
          <br />
          <hr />
          <br />
          <div className="row">
            <div className="col-md-4">
              <h4>Number Plate</h4>
              <strong>{this.state.data.vehicle.registration_number}</strong>
              {(appraisal.number_plate &&
                appraisal.number_plate[type] &&
                appraisal.number_plate[type].entry) ?
                <h5>Entry:&nbsp;
                  <strong>
                    {appraisal.number_plate[type].entry}
                  </strong>
                </h5>
                :
                <h5>No entry.</h5>
              }
              <br />
            </div>

            <div className="col-md-4">
              <h4>VIN</h4>
              <strong>{this.state.data.vehicle.vin_number}</strong>
              {(appraisal.vin &&
                appraisal.vin[type] &&
                appraisal.vin[type].entry) ?
                <h5>Entry:&nbsp;
                  <strong>
                    {appraisal.vin[type].entry}
                  </strong>
                </h5>
                :
                <h5>No entry.</h5>
              }
            </div>


            <div className="col-md-4">
              <h4>Warning Lights</h4>
              {(appraisal.warning_light &&
                appraisal.warning_light[type] &&
                appraisal.warning_light[type].value) ?
                <h5>Entry:
                  <strong>
                    {appraisal.warning_light[type].label}
                  </strong>:
                  {appraisal.warning_light[type].value}
                </h5>
                :
                <h5>Entry: <strong>No warning lights</strong></h5>
              }
              <br />
            </div>
          </div>

          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Rear</h4>
                </div>
              </div>
              {(appraisal.manual_appraisal[type].rear) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].rear) : null}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Front</h4>
                </div>
              </div>
              
              {(appraisal.manual_appraisal[type].front) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].front) : null}
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Driver Side</h4>
                </div>
              </div>
              {(appraisal.manual_appraisal[type].driver_side) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].driver_side) : null}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <h4>Passenger Side</h4>
                </div>
              </div>
              {(appraisal.manual_appraisal[type].passenger_side) ? this.renderNewKeysAboveMileage(appraisal.manual_appraisal[type].passenger_side) : null}
            </div>
          </div>
          <hr />
          
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Mileage</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.mileage &&
                    appraisal.mileage[type] &&
                    appraisal.mileage[type].entry) ?
                    <h5><strong>{appraisal.mileage[type].entry}</strong></h5>
                    :
                    <h5>No entry.</h5>
                  }
                  <br />
                </div>
              </div>

              {this.renderManualAppraisalMileageImages(appraisal, type)}
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <h4>Petrol Level</h4>
                </div>
                <div className="col-md-6">
                  {(appraisal.petrol_level &&
                    appraisal.petrol_level[type] &&
                    appraisal.petrol_level[type].entry) ?
                    <h5>About&nbsp;
                      <strong>
                        {appraisal.petrol_level[type].entry}%
                      </strong>
                    </h5>
                    :
                    <h5>No entry.</h5>
                  }<br />
                </div>
              </div>
              {this.renderManualAppraisalPetrolLevelImages(
                appraisal, type
              )}
            </div>
          </div>
          <hr />
          <h4 className="text-center">Manual Appraisal</h4>
          <h5>Vehicle Info</h5>
          {this.renderManualAppraisalVehicleInfo(appraisal, type)}
          <div>&nbsp;</div>
          <h5>Vehicle Parts</h5>
          {this.renderManualAppraisalVehicleParts(appraisal, type)}
          <hr />
          <h4 className="text-center">Appraisal Feedback</h4>
          {this.renderAppraisalFeedbackQuestions(appraisal, type)}
          <hr />
          <h4 className="text-center">Video Appraisal</h4>
          <div className="row">
            {this.renderVideoAppraisalBlock(appraisal, type)}
          </div>
          {signatureBlock}
        </div>
      );
    }
    else {
      appraisalInfoBlock =(
        <div className="row" key={'appraisal-info-block-for'+appraisal.id}>
          <div className="col-md-12">
            <p>
              <strong>
                No Appraisal Yet.
              </strong>
            </p>
          </div>
        </div>
      )
    }

    return appraisalInfoBlock;
  }

  renderVideoAppraisalBlock(appraisal, type) {
    let videoBlock;
    videoBlock = [];
    let ii = 0;
    let jobId = this.state.data.id;
    if (this.state.data.video_appraisal_required === 1 &&
      appraisal.video_appraisal &&
      appraisal.video_appraisal[type]) {
      if (appraisal.video_appraisal[type].videos.length > 0) {
        appraisal.video_appraisal[type].videos.forEach(function(i) {
          ii++;
          videoBlock.push(
            <VimeoVideo key={'job-'+jobId+'-vimeo-'+ii} data={i} />
          );
        });
      }
      else {
        videoBlock =  (
          <p><strong>No videos yet.</strong></p>
        );
      }
    }
    else {
      videoBlock = (<div>video appraisal not required</div>);
    }
    return videoBlock;
  }
  render() {
    var downloadButtonText = '';
    if(this.state.isDownloadClick)
    {
      downloadButtonText = 'Downloading ... ';
    }
    else {
      downloadButtonText = '<i className="fa fa-download"></i> Download <span className="uc-first">'+this.state.type+'</span> Appraisal as PDF';
    }
    return (
      <div>
        &nbsp;
        <small>
          <em>- generated {
            moment().format(
              'ddd Do MMM YYYY - HH:mm:ss'
            ).toString()
          }</em>
        </small>
        {this.state.isLoadingAppraisalInfo ?
          <div className="loading-box">
            <span className="add-loading-text">
              <i className="fa fa-spinner fa-pulse"></i>
            </span>
          </div> :
          this.state.data && this.state.data.id ?
          <div>
              <a href="#"
               onClick={(e) => {
                 this.downloadAppraisalForJob(e,
                   "job-"+this.state.data.id+"-"+this.state.type+"-appraisal",
                   moment().format('ddd Do MMM YYYY - HH:mm:ss')
                 )
               }}
               className="btn btn-lg btn-success appraisal-download-button pickDropAppraisal">
               <div dangerouslySetInnerHTML={{__html: downloadButtonText}} />
                </a>
              <br/>
              <div className="row">
                <div className="col-md-4">
                  {(this.state.data && this.state.data.id && !this.state.customerAllJobsPage && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data) ? 
                    (this.state.type == "pickup") ? 
                      (this.state.data.approve_pickup_appraisal) ? 
                        <button className="btn btn-dark pickup font-16" 
                          onClick={(e) => {this.unapproveAppraisal(e,this.state.type)}}>
                          UnApprove {this.state.type} Appraisal to be shown on customer login 
                        </button>
                      : 
                      <button className="btn btn-primary pickup font-16" 
                        onClick={(e) => {this.approveAppraisal(e,this.state.type)}}>
                        Approve {this.state.type} Appraisal to be shown on customer login 
                      </button>
                    : ""
                  : ""}
                  {(this.state.data && this.state.data.id && !this.state.customerAllJobsPage && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data) ? 
                    (this.state.type == "dropoff") ? 
                      (this.state.data.approve_dropoff_appraisal) ? 
                        <button className="btn btn-dark dropoff font-16" 
                          onClick={(e) => {this.unapproveAppraisal(e,this.state.type)}}>
                          UnApprove {this.state.type} Appraisal to be shown on customer login 
                        </button>
                      : 
                      <button className="btn btn-primary dropoff font-16" 
                        onClick={(e) => {this.approveAppraisal(e,this.state.type)}}>
                        Approve {this.state.type} Appraisal to be shown on customer login 
                      </button>
                    : ""
                  : ""}
                </div>
                {(this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data) ? 
                <div className="col-md-4">
                    <button className="btn btn-dark dropoff font-16 text-uppercase" 
                        onClick={(e) => {this.sendAppraisalPdfMailToCustomer(e,this.state.type)}}>
                       SEND {this.state.type} APPRAISAL PDF {(this.state.customerAllJobsPage) ? 'BY EMAIL' : 'MAIL TO CUSTOMER'}
                    </button>
                </div>
                : ""}

                {(this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && this.state.data.customer && this.state.data.customer.disclaimer && "number_plate" in this.state.appraisal_data) ? 
                <div className="col-md-4">
                    <textarea className="form-control form-control-lg"
                        id="customer_disclaimer"
                        readOnly={true}
                        defaultValue={this.state.data.customer.disclaimer}>
                    </textarea>
                </div>
                : ""}
              </div>

              
              <br/><br/>
            { this.state.type == "dropoff" && this.state.data && this.state.data.id && typeof this.state.appraisal_data == "object" && "number_plate" in this.state.appraisal_data ?
                <button className="btn btn-primary pull-right" onClick={(e) => {this.handleCheckDiffAppraisals(e)}}>Check Appraisal</button> : 
                ''
            }
            
            {this.renderAppraisalInfoBlock(this.state.type)}
          </div>
            : alert('no id')
        }
      </div>
    );
  }
}

